import { ComponentType } from '@angular/cdk/portal'
import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    constructor(private dialog: MatDialog) {}

    getDialogOptions<T>(data: T, disableClose: boolean): MatDialogConfig<T> {
        return {
            data,
            disableClose,
            hasBackdrop: true,
            maxHeight: '95vh',
            maxWidth: '95vw',
            panelClass: 'wp',
            position: { top: '10%' },
            width: '450px',
        }
    }

    getV2DialogOptions<T>(data: T, disableClose: boolean): MatDialogConfig<T> {
        return {
            data,
            disableClose,
            hasBackdrop: true,
            maxHeight: '95vh',
            maxWidth: '95vw',
            panelClass: 'custom-dialog-container',
            position: { top: '10%' },
            width: '664px',
        }
    }

    async wrapInDialog<T, U>(component: ComponentType<T>, action: () => Promise<U>): Promise<U> {
        let saveDialog: MatDialogRef<T> | undefined
        let timeout: NodeJS.Timeout | undefined
        try {
            timeout = setTimeout(() => {
                timeout = undefined
                saveDialog = this.dialog.open(component, {
                    width: '300px',
                    panelClass: ['wp-dialog', 'animated', 'fadeIn', 'fastest'],
                    disableClose: true,
                })
            }, 50)

            return await action()
        } finally {
            if (timeout) {
                clearTimeout(timeout)
            }
            saveDialog?.close()
        }
    }
}
